import { ComprehensibleSubscriptionPrice } from "types/subscription/price";
import { getFormattedSum } from "helpers/shared";

import { GetSubscriptionPriceResponseDto } from "utils/swagger_react_query";

/**
 * Get the base and additional prices from the subscription price response
 * @param price - The subscription price response
 * @returns The base and additional prices
 * @example
 * return {
 *  basePrice: "$15.00",
 *  additionalPrice: "$5.00",
 * }
 */
export const getComprehensibleSubscriptionPrice = (
  price: GetSubscriptionPriceResponseDto | null | undefined,
): ComprehensibleSubscriptionPrice => {
  if (!price) {
    console.error("No price found");
    return {
      basePrice: "",
      additionalPrice: "",
    };
  }
  const baseTier = price.tiers.find(
    (tier) => tier.unitFrom === 0 && Number(tier.flatPrice.replace("$", "")) > 0,
  );

  const additionalTier = price.tiers.find((tier) => Number(tier.unitPrice.replace("$", "")) > 0);

  return {
    basePrice: baseTier?.flatPrice
      ? getFormattedSum(baseTier.flatPrice, { precision: 0 }, false)
      : "",
    additionalPrice: additionalTier?.unitPrice
      ? getFormattedSum(additionalTier.unitPrice, { precision: 0 }, false)
      : "",
  };
};
